import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material';
import { AdministrationService } from '../../../services/administration.service'
import { WMSValidators } from '../../../shared/validators';

@Component({
    selector: 'dialog-add-new-fare',
    templateUrl: 'dialog.addnewfare.html',
    styleUrls: ['./dialog.addnewfare.css']
})
export class AddNewFareDialog implements OnInit, OnDestroy {
    allSub: Subscription[] = [];
    loading: boolean = false;
    errorMessage: string = '';
    addFareform: FormGroup;
    statusList = this.data.StatusList;

    constructor(public dialogRef: MatDialogRef<AddNewFareDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private administrationService: AdministrationService,
        public snackBar: MatSnackBar) { }

    ngOnInit() {
        this.addFareform = new FormGroup({
            departureStation: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.minLength(3), Validators.maxLength(3), WMSValidators.letterOnly]),
            arrivalStation: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(3), WMSValidators.letterOnly]),
            baseFare: new FormControl({ value: '', disabled: false }, [Validators.required, WMSValidators.currency]),
            airportTax: new FormControl({ value: '', disabled: false }, [Validators.required, WMSValidators.currency]),
            fuelSurcharge: new FormControl({ value: '', disabled: false }, [Validators.required, WMSValidators.currency]),
            totalPayment: new FormControl({ value: '0.00', disabled: true }),
            commenceDate: new FormControl({ value: new Date(), disabled: false }, [Validators.required]),
            fareStatus: new FormControl({ value: 'Active', disabled: true })
        });
    }

    commenceDateOnChange(e) {
    }

    onSubmit(form: FormGroup) {
        let cfm = confirm("Are you sure you want to add new fare?");

        if (cfm) {
            this.loading = true;
            let fareDetail = {
                DepartureStation: this.addFareform.get('departureStation')!.value,
                ArrivalStation: this.addFareform.get('arrivalStation')!.value,
                BaseFareAmt: this.addFareform.get('baseFare')!.value,
                AirPortTax: this.addFareform.get('airportTax')!.value,
                FuelSurcharge: this.addFareform.get('fuelSurcharge')!.value,
                PymntAmt: this.addFareform.get('totalPayment')!.value,
                CommenceDate: this.addFareform.get('commenceDate')!.value,
                FareStatusCode: true,
                UserName: ''
            }

            let save_sub = this.administrationService.addFareDetails(fareDetail)
                .subscribe(
                    (value) => {
                        if (value.status === 204) {
                        } else if (value.status === 200) {
                            this.loading = false;
                            this.dialogRef.close('Save successful');
                        } else {
                        }
                    },
                    (error) => {
                        this.errorMessage = <any>error;
                        this.openSnackBar(this.errorMessage, '');
                    });

            //Adds into array for each subscribe
            this.allSub.push(save_sub);
        } else {
            this.loading = false;
        }
    }

    toUpper() {
        this.addFareform.setValue({
            departureStation: this.addFareform.get('departureStation')!.value.trim().toUpperCase(),
            arrivalStation: this.addFareform.get('arrivalStation')!.value.trim().toUpperCase(),
            baseFare: this.addFareform.get('baseFare')!.value,
            airportTax: this.addFareform.get('airportTax')!.value,
            fuelSurcharge: this.addFareform.get('fuelSurcharge')!.value,
            totalPayment: this.addFareform.get('totalPayment')!.value,
            commenceDate: this.addFareform.get('commenceDate')!.value,
            fareStatus: this.addFareform.get('fareStatus')!.value
        });
    }

    sumPayment() {
        this.addFareform.setValue({
            departureStation: this.addFareform.get('departureStation')!.value,
            arrivalStation: this.addFareform.get('arrivalStation')!.value,
            baseFare: this.addFareform.get('baseFare')!.value,
            airportTax: this.addFareform.get('airportTax')!.value,
            fuelSurcharge: this.addFareform.get('fuelSurcharge')!.value,
            totalPayment: this.convertToNumber(this.addFareform.get('baseFare')!.value) +
                this.convertToNumber(this.addFareform.get('airportTax')!.value) +
                this.convertToNumber(this.addFareform.get('fuelSurcharge')!.value),
            commenceDate: this.addFareform.get('commenceDate')!.value,
            fareStatus: this.addFareform.get('fareStatus')!.value
        });
    }

    convertToNumber(value) {
        if (isNaN(Number(value))) {
            return 0;
        }

        return Number(value);
    }

    ngOnDestroy() {
        for (let sub of this.allSub) {
            sub.unsubscribe();
        }
    }

    openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 3000,
        });
    }
}